import { Inject, Injectable } from '@angular/core';
import {
  SwUpdate, VersionDetectedEvent, VersionInstallationFailedEvent, VersionReadyEvent,
} from '@angular/service-worker';

import { filter } from 'rxjs';

import { MdbNotificationService, MdbNotificationRef, MdbNotificationConfig } from 'src/lib/mdb5-adapted/public-api';
import { SimpleNotificationComponent } from 'src/app/shared/notification/simple-notification.component';
import { WINDOW } from './window.token';

/** @dynamic */
@Injectable({
  providedIn: 'root',
})
export class ServiceWorkerService {
  private snackBarRef: MdbNotificationRef<any>;

  constructor(@Inject(WINDOW) private window: Window, private swUpdate: SwUpdate,
    public _snackBar: MdbNotificationService) {}

  isOffline: boolean = true;
  modalVersion: boolean = false;
  modalPwaEvent: any;
  modalPwaPlatform: string|undefined;
  updateCheckText = '';

  checkSWUpdate() {
    if (!this.swUpdate.isEnabled) {
      console.log('Service Worker is not enabled');
      return;
    }

    console.log('Service Worker: Checking for updates...');

    // Subscribe to version updates with proper RxJS pipeline
    this.swUpdate.versionUpdates.pipe(
      filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY')
    ).subscribe((evt) => {
      console.log(`Current app version: ${evt.currentVersion.hash}`);
      console.log(`New app version ready for use: ${evt.latestVersion.hash}`);

      this.modalVersion = true;
      this.isOffline = false;

      const config: MdbNotificationConfig = {
        position: 'top-center',
        autohide: false,
        data: {
          message: 'Newer version of the app is available',
          title: 'Update Available',
          action: 'Refresh'
        }
      };

      this.snackBarRef = this._snackBar.open(SimpleNotificationComponent, config);

      this.snackBarRef.onClose.subscribe((result) => {
        if (result === 'action') {
          console.log('User clicked Refresh - reloading page');
          this.window.location.reload();
        }
      });
    });

    // Subscribe to version detection
    this.swUpdate.versionUpdates.pipe(
      filter((evt): evt is VersionDetectedEvent => evt.type === 'VERSION_DETECTED')
    ).subscribe((evt) => {
      const config: MdbNotificationConfig = {
        position: 'top-center',
        autohide: true,
        delay: 7000,
        data: {
          message: 'New CLMS version was detected, downloading version.. Wait for the notification to refresh after download is complete',
          title: 'Downloading Update',
          action: 'Dismiss'
        }
      };

      this._snackBar.open(SimpleNotificationComponent, config);

      console.log(`Downloading new app version: ${evt.version.hash}`);
      this.isOffline = true;
      this.modalVersion = false;
    });

    // Subscribe to installation failures
    this.swUpdate.versionUpdates.pipe(
      filter((evt): evt is VersionInstallationFailedEvent => evt.type === 'VERSION_INSTALLATION_FAILED')
    ).subscribe((evt) => {
      console.log(`Failed to install app version '${evt.version.hash}': ${evt.error}`);
      this.isOffline = false;
      this.modalVersion = false;

      const config: MdbNotificationConfig = {
        position: 'top-center',
        autohide: true,
        delay: 5000,
        data: {
          message: 'Failed to install new CLMS version',
          title: 'Installation Failed',
          action: 'Dismiss'
        }
      };

      this._snackBar.open(SimpleNotificationComponent, config);
    });

    // Check for new version immediately
    this.swUpdate.checkForUpdate()
      .then(() => {
        console.log('Service Worker: Update check completed');
        this.updateCheckText = 'resolved';
      })
      .catch(err => {
        console.error('Service Worker: Update check failed', err);
        this.updateCheckText = `rejected: ${err.message}`;
      });
  }

  // // TODO: move to appState/eventBus?
  // checkSWUpdate(): void {
  //   if (environment.production) {
  //     // Subscribe new worker is available
  //     this.swUpdate.available.subscribe((event) => {
  //       console.log('Current version is', event.current);
  //       console.log('Available version is', event.available);
  //       // update available: ask the user to reload
  //       const snackBarRef = this.snackBar.open('Newer version of the app is available', 'Refresh');

  //       snackBarRef.onAction().subscribe(() => {
  //         window.location.reload();
  //       });
  //     });

  //     this.swUpdate.activated.subscribe((event) => {
  //       console.log('Old version was', event.previous);
  //       console.log('New version is', event.current);
  //     });

  //     // Check for new version
  //     this.swUpdate.checkForUpdate();
  //   }
  // }
}
